import React from 'react';
import { Link } from 'react-router-dom';
import {
  Sparkles, Heart, DollarSign, ChevronRight, Clock, Calendar,
  Crown, ArrowDownToLine
} from 'lucide-react';

export function QuickActions({ isProfessional }) {
  return (
    <div className="card-theraflow p-6" data-testid="quick-actions">
      <h3 className="text-lg font-medium text-[#292927] mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
        Ações Rápidas
      </h3>
      <div className="space-y-3">
        <Link to="/match" className="flex items-center justify-between p-4 rounded-xl bg-[#4A5D4E] hover:bg-[#3E4E41] transition-colors" data-testid="quick-match-link">
          <div className="flex items-center gap-3">
            <Sparkles className="w-5 h-5 text-white" strokeWidth={1.5} />
            <span className="font-medium text-white">Match IA</span>
          </div>
          <ChevronRight className="w-5 h-5 text-white/70" strokeWidth={1.5} />
        </Link>
        <Link to="/payments" className="flex items-center justify-between p-4 rounded-xl bg-[#F6EBE6] hover:bg-[#EBDCD5] transition-colors" data-testid="quick-payments-link">
          <div className="flex items-center gap-3">
            <DollarSign className="w-5 h-5 text-[#4A5D4E]" strokeWidth={1.5} />
            <span className="font-medium text-[#292927]">Tipos de Assistência</span>
          </div>
          <ChevronRight className="w-5 h-5 text-[#A0A09A]" strokeWidth={1.5} />
        </Link>
        <Link to="/professionals" className="flex items-center justify-between p-4 rounded-xl bg-[#F6EBE6] hover:bg-[#EBDCD5] transition-colors" data-testid="quick-browse-link">
          <div className="flex items-center gap-3">
            <Heart className="w-5 h-5 text-[#4A5D4E]" strokeWidth={1.5} />
            <span className="font-medium text-[#292927]">Ver Profissionais</span>
          </div>
          <ChevronRight className="w-5 h-5 text-[#A0A09A]" strokeWidth={1.5} />
        </Link>
        {isProfessional && (
          <>
            <Link to="/withdrawals" className="flex items-center justify-between p-4 rounded-xl bg-[#F6EBE6] hover:bg-[#EBDCD5] transition-colors" data-testid="quick-withdrawals-link">
              <div className="flex items-center gap-3">
                <ArrowDownToLine className="w-5 h-5 text-[#4A5D4E]" strokeWidth={1.5} />
                <span className="font-medium text-[#292927]">Solicitar Saque</span>
              </div>
              <ChevronRight className="w-5 h-5 text-[#A0A09A]" strokeWidth={1.5} />
            </Link>
            <Link to="/featured-plans" className="flex items-center justify-between p-4 rounded-xl bg-[#D4A373]/10 hover:bg-[#D4A373]/20 transition-colors" data-testid="quick-featured-link">
              <div className="flex items-center gap-3">
                <Crown className="w-5 h-5 text-[#D4A373]" strokeWidth={1.5} />
                <span className="font-medium text-[#292927]">Planos de Destaque</span>
              </div>
              <ChevronRight className="w-5 h-5 text-[#A0A09A]" strokeWidth={1.5} />
            </Link>
          </>
        )}
      </div>
    </div>
  );
}

export function StatsSection({ sessions, upcomingCount }) {
  return (
    <div className="card-theraflow p-6" data-testid="user-stats">
      <h3 className="text-lg font-medium text-[#292927] mb-4" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
        Sua Jornada
      </h3>
      <div className="space-y-4">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-[#4A5D4E]/10 flex items-center justify-center">
            <Clock className="w-6 h-6 text-[#4A5D4E]" strokeWidth={1.5} />
          </div>
          <div>
            <p className="text-2xl font-light text-[#292927]">
              {sessions.filter(s => s.status === 'completed').length}
            </p>
            <p className="text-sm text-[#A0A09A]">Sessões realizadas</p>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-[#6B8E7C]/10 flex items-center justify-center">
            <Calendar className="w-6 h-6 text-[#6B8E7C]" strokeWidth={1.5} />
          </div>
          <div>
            <p className="text-2xl font-light text-[#292927]">{upcomingCount}</p>
            <p className="text-sm text-[#A0A09A]">Sessões agendadas</p>
          </div>
        </div>
      </div>
    </div>
  );
}
